import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { CloseIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import FilterSelect from 'UiKit/filter-select';
import SearchComponent from 'UiKit/search';
import { TextSemiBold } from 'UiKit/typography';

import useGetBrand from 'Domain/brand/useGetBrand';
import useGetRequestApprovalType from 'Domain/reschedule/useGetRequestApprovalType';
import useGetRequestApprovalStatus from 'Domain/reschedule/useGetRequestApprovalStatus';
import { useRequestApprovalState } from 'View/reschedule/state';

import styles from './styles.module.css';

const Filter = () => {
  const { t } = useTranslation('reschedule');
  const { state, filterState, updateFilterState, resetFilterState } = useRequestApprovalState();

  const { data: brandOptions, isLoading: isLoadingBrand } = useGetBrand();
  const { data: typeOptions, isLoading: isLoadingType } = useGetRequestApprovalType();
  const { data: statusOptions, isLoading: isLoadingStatus } = useGetRequestApprovalStatus();

  const isResetAllFilter = filterState?.search || filterState?.brand?.length > 0 || filterState?.typeId?.length > 0 || filterState?.statusProgress?.length > 0;

  const onChangeFilter = (newFilter) => updateFilterState({ ...newFilter, page: 1 });
  const resetFilter = () => resetFilterState();

  return (
    <Box className={styles['filter-request-approval__wrapper']}>
      <Flex className={styles['filter-request-approval__container']}>
        <Flex className={styles['left__section']} gap={'12px'}>
          <SearchComponent value={filterState?.search} onSearch={(value) => onChangeFilter({ search: value })} maxWidth="320px" />

          <Box>
            <FilterSelect
              value={filterState?.brand}
              onChange={(value) => onChangeFilter({ brand: value })}
              placeholder={t('filterBrandPlaceholder')}
              clearable={true}
              options={brandOptions}
              isLoading={isLoadingBrand}
              isMulti={true}
              counterLabel={t('filterBrandCounter')}
              width="140px"
            />
          </Box>

          <Box>
            <FilterSelect
              value={filterState?.typeId}
              onChange={(value) => onChangeFilter({ typeId: value })}
              placeholder={t('filterTypePlaceholder')}
              clearable={true}
              options={typeOptions}
              isLoading={isLoadingType}
              isMulti={true}
              counterLabel={t('filterTypeCounter')}
              width="150px"
            />
          </Box>

          <Condition statement={state?.selectedTab === 'done'}>
            <Box>
              <FilterSelect
                value={filterState?.statusProgress}
                onChange={(value) => onChangeFilter({ statusProgress: value })}
                placeholder={t('filterStatusPlaceholder')}
                clearable={true}
                options={statusOptions}
                isLoading={isLoadingStatus}
                isMulti={true}
                counterLabel={t('filterStatusCounter')}
                width="120px"
              />
            </Box>
          </Condition>

          <Condition statement={isResetAllFilter}>
            <Flex onClick={resetFilter} className={styles['reset-filter__container']}>
              <CloseIcon size="14px" color="var(--color-semantic-text)" />
              <TextSemiBold>{t('clearFilters')}</TextSemiBold>
            </Flex>
          </Condition>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Filter;
